export const portfolioRoutePaths = {
  portfolio: {
    path: 'portfolio',
    fullPath: '/portfolio',
  },
};
